import React from 'react';
import { FiX, FiDroplet } from 'react-icons/fi';

const AboutModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4 transition-opacity duration-300" onClick={onClose}>
      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-lg mx-auto p-6 transition-transform duration-300 transform scale-100" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <FiX size={24} />
        </button>
        <div className="flex flex-col items-center text-center">
          <FiDroplet size={48} className="text-teal-500 mb-4 animate-pulse" />
          <h2 className="text-2xl font-bold mb-4">درباره ما</h2>
          <p className="text-gray-700 mb-3">
            ما تیمی متشکل از متخصصان پوست و مهندسان هوش مصنوعی هستیم که با هدف ارتقاء سلامت و زیبایی پوست، این اپلیکیشن را طراحی کرده‌ایم.
          </p>
          <p className="text-gray-700 mb-3">
            درمو وایز با بهره‌گیری از فناوری پیشرفته تحلیل پوست، به شما کمک می‌کند تا وضعیت پوست خود را بهتر بشناسید و با یک دستیار هوشمند همیشه در کنار خود، مراقبتی شخصی‌سازی‌شده و علمی را تجربه کنید.
          </p>
          <p className="text-gray-700">
            ما اینجا هستیم تا همراه شما در مسیر داشتن پوستی سالم‌تر و شاداب‌تر باشیم.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutModal; 